import React from "react";

import { useState, useEffect } from "react";
import "./BlockDetails.css";
import { useTranslation } from "react-i18next";
import Table from "../../../Components/UiComponents/Table/Table";

const DistrictBlockDetails = ({ data, activeTab, setActiveTab }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = data?.filter((item) =>
    (item.dist_name || item.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
    (item.block_name || "").toLowerCase().includes(searchTerm.toLowerCase())
  ) || [];

  return (
    <div className="premium-impact-list-container">
      {/* Search and Tabs Header */}
      <div className="d-flex justify-content-between align-items-center mb-4 px-1">
        {/* Styled Tab Switcher */}
        <div className="d-flex p-1" style={{ 
          background: "rgba(42,101,145,.06)", 
          borderRadius: "10px",
          gap: "4px"
        }}>
          <button
            onClick={() => setActiveTab("Affected")}
            style={{
              border: "none",
              padding: "6px 16px",
              borderRadius: "8px",
              fontSize: "0.72rem",
              fontWeight: "700",
              cursor: "pointer",
              transition: "all .2s",
              background: activeTab === "Affected" ? "#2A6591" : "transparent",
              color: activeTab === "Affected" ? "#fff" : "#3A5F78",
              boxShadow: activeTab === "Affected" ? "0 2px 6px rgba(42,101,145,.2)" : "none"
            }}
          >
            Affected
          </button>
          <button
            onClick={() => setActiveTab("Partially Affected")}
            style={{
              border: "none",
              padding: "6px 16px",
              borderRadius: "8px",
              fontSize: "0.72rem",
              fontWeight: "700",
              cursor: "pointer",
              transition: "all .2s",
              background: activeTab === "Partially Affected" ? "#2A6591" : "transparent",
              color: activeTab === "Partially Affected" ? "#fff" : "#3A5F78",
              boxShadow: activeTab === "Partially Affected" ? "0 2px 6px rgba(42,101,145,.2)" : "none"
            }}
          >
            Partial
          </button>
        </div>

        {/* Search */}
        <div className="d-flex align-items-center" style={{ 
          background: "#fff", 
          border: "1px solid rgba(42,101,145,.15)", 
          borderRadius: "8px",
          padding: "2px 8px"
        }}>
          <input
            type="text"
            placeholder="Search..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ 
              border: "none", 
              outline: "none", 
              fontSize: "0.75rem", 
              padding: "4px",
              width: "120px"
            }}
          />
          <svg viewBox="0 0 24 24" fill="none" width="14" height="14" stroke="#7A9BB0" strokeWidth="2">
            <circle cx="11" cy="11" r="8" />
            <path d="m21 21-4.3-4.3" />
          </svg>
        </div>
      </div>

      <div className="premium-impact-list">
        {filteredData.length > 0 ? (
          filteredData.map((item, i) => (
            <div key={i} className="avd-popup-row">
              <div className="avd-popup-row-left">
                <div className="avd-popup-row-num">{i + 1}</div>
                <svg viewBox="0 0 24 24" fill="none" width="14" height="14" stroke="#2A6591" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z" />
                  <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2" />
                  <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2" />
                </svg>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <span>{item.dist_name || item.name}</span>
                  {item.block_name && (
                    <span style={{ fontSize: "0.65rem", color: "#7A9BB0", marginTop: "-2px" }}>
                      {item.block_name}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="avd-popup-empty">
            <div className="mb-2">🗺️</div>
            <div>No matching results found</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DistrictBlockDetails;
